export default function CategoryVacancyRenderer({ section }) {

    const data = section?.value || {};

    const posts = Object.keys(data);

    // Detect if this is the old simple format
    const firstValue = posts.length ? data[posts[0]] : null;
    const isPostWise =
        firstValue &&
        typeof firstValue === "object" &&
        !Array.isArray(firstValue);

    // -----------------------------
    // Old Format
    // SC, ST, OBC ...
    // -----------------------------
    if (!isPostWise) {

        return (

            <table className="table">

                <tbody>

                    {Object.entries(data).map(([category, vacancies]) => (

                        <tr key={category}>
                            <td><b>{category}</b></td>
                            <td>{vacancies}</td>
                        </tr>

                    ))}

                </tbody>

            </table>

        );

    }

    // -----------------------------
    // New IBPS Format
    // -----------------------------
    return (

        <div className="category-vacancy">

            <table className="table table-bordered">

                <thead>

                    <tr>

                        <th>Post</th>
                        <th>UR</th>
                        <th>OBC</th>
                        <th>SC</th>
                        <th>ST</th>
                        <th>EWS</th>
                        <th>Total</th>
                        <th>HI</th>
                        <th>OC</th>
                        <th>VI</th>
                        <th>ID</th>

                    </tr>

                </thead>

                <tbody>

                    {posts.map((post) => (

                        <tr key={post}>

                            <td>{post}</td>

                            <td>{data[post].UR}</td>
                            <td>{data[post].OBC}</td>
                            <td>{data[post].SC}</td>
                            <td>{data[post].ST}</td>
                            <td>{data[post].EWS}</td>
                            <td>{data[post].TOTAL}</td>
                            <td>{data[post].HI}</td>
                            <td>{data[post].OC}</td>
                            <td>{data[post].VI}</td>
                            <td>{data[post].ID}</td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}